import { render, staticRenderFns } from "./InsuranceInvestment.vue?vue&type=template&id=ef03032c&scoped=true"
import script from "./InsuranceInvestment.vue?vue&type=script&lang=js"
export * from "./InsuranceInvestment.vue?vue&type=script&lang=js"
import style0 from "./InsuranceInvestment.vue?vue&type=style&index=0&id=ef03032c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef03032c",
  null
  
)

export default component.exports